import { TopLogoView } from "@quest/murka-games-behavior-panther/dist/Game/TopLogo/TopLogoView";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { dispatcher, ingenuity } from "@quest/base-core";
import { SlotConstantsBehavior } from "@quest/murka-games-behavior-panther";

export class TopLogoViewGame extends TopLogoView {
  /**
   * to add collection panel over the logo
   */
  public topSpace(): void {
    super.topSpace()
    if (this.currentStateView) {
      dispatcher.fireEvent(eventDispatchers.ADD_COLLECTION_ON_TOP);
      dispatcher.fireEvent(eventDispatchers.ADD_COLLECTION_BANNER_ON_TOP);
      dispatcher.fireEvent(eventDispatchers.ADD_RESPIN_INTRO_OUTRO_ON_TOP);
      dispatcher.fireEvent(eventDispatchers.ADD_BANNER_ON_TOP);

    }
  }
  showView() {
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstantsBehavior.baseGameState || ingenuity.configData.showBaseGameScreen ) {
      this.visible = true;
    }
    else {
      this.hideView();
    }
  }
}